import VulnerabilityDetailsMainInformation from './VulnerabilityDetailsMainInformation';

export default VulnerabilityDetailsMainInformation;
export { VulnerabilityDetailsMainInformation };
